<template>
	<div class="page padded">

		<div class="centered mw-narrow" >
			<div class="raised-box">
				<div v-if="!invite" >
					<div class="p-box">
						<h1>Invalid invite</h1>
						<p>Oh dear! Looks like your invite link no longer works.</p>
						<p>This is normally because you have already used it to create an account.</p>
						<p><router-link :to="{name:'auth.login'}" class="btn-a">Try logging in</router-link></p>
					</div>
				</div>
				<div v-else-if="!existing_account">

					<div class="p-box c-bg-grad-core t-invert">
						<p class="t-big" >Create your {{ invite.org.name }} team account now</p>
						<p>Create an account now to join {{ apostrophize(invite.org.name) }} wayleave management panel.</p>
						<button v-on:click="toggleExisting" class="btn-outline-white" >I already have an account</button>
					</div>
					<div class="p-box">
						<RegisterForm :invite="invite"  />
					</div>

				</div>
				<div v-else>

					<div class="p-box c-bg-grad-core t-invert">
						<p class="t-big" >Join the {{ invite.org.name }} team</p>
						<p>Sign into your account now to join {{ apostrophize(invite.org.name) }} wayleave management panel.</p>
						<button v-on:click="toggleExisting" class="btn-outline-white" >I don't have an account</button>
					</div>
					<div class="p-box">
						<LoginForm :invite="invite" />
					</div>

				</div>
			</div>

		</div>

	</div>

</template>

<script>

	import LoginForm from '../../forms/LoginForm';
	import RegisterForm from '../../forms/RegisterForm';

	var loadedinvite = null;

	export default {
		components: {
			LoginForm,
			RegisterForm,
		},

		data() {
			return {
				invite : loadedinvite,
				existing_account: (loadedinvite||{}).user_exists_with_that_email,
			};
		},

		beforeRouteEnter(to,from,next){
			var self = this;
			api.get('invite',to.params.invite_id)
				.then((invite) => {
					loadedinvite = invite;
				})
				.catch(() => {
					loadedinvite = null;
					// alert( (response && response.data && response.data.message) ? response.data.message : 'Failed to find invite information' );
				})
				.then((invite) => {
					next();
				})
				;
		},
		methods: {
			apostrophize(str){
				return str + (str.endsWith('s') ? "'" : "'s" );
			},
			toggleExisting(){
				this.existing_account = !this.existing_account;
			},
		}

	}

</script>